<div translate class="e-error-notice" *ngIf="visible && errorMessage !== null"
  [translateParams]="{ minValue: validatorValues.minValue, maxValue: validatorValues.maxValue }">
  {{ errorMessage }}
</div>